import { useLocation } from "react-router-dom";

import { tituloDe, universoDe } from "./secciones";

/* El encabezado de cada pantalla: qué es esto y para qué sirve.
 *
 * QUÉ RESUELVE. Las veinte pantallas propias del hub abrían directamente en su
 * tabla o su formulario, sin decir dónde estabas parado. El nombre sólo se leía
 * en el rail —chiquito, en una lista de veinte— y si el rail estaba plegado, en
 * ningún lado. Eso hace que el sistema se sienta un montón de tablas sueltas en
 * vez de una aplicación.
 *
 * ── Y ES EL ÚNICO QUE LO DIBUJA. ANTES ERAN DOS ──────────────────────────
 *
 * `Header` resolvía el mismo rótulo con **otra** función —había dos `tituloDe`,
 * una acá y otra en `secciones.js`— y las dos se dibujaban: el nombre de la
 * pantalla aparecía **dos veces**, una en la barra de arriba y otra acá abajo.
 * No rompía nada, y es exactamente lo que hace que una aplicación se lea como
 * dos pegadas — la misma costura que FlotaBot sacó con `data-embebido`.
 *
 * Peor: las dos listas de respaldo **no decían lo mismo**. La de acá no conocía
 * `/cambiar-password` ni `/recursos`, así que en esas dos pantallas la barra de
 * arriba mostraba el título y el contenido abría sin ninguno.
 *
 * Ahora la búsqueda es una sola (`secciones.tituloDe`, que vive con el
 * catálogo) y el que la dibuja es éste. `Header` se quedó con la marca, que es
 * lo suyo.
 *
 * NO VA EN LAS PANTALLAS DEL PANEL DE FLOTABOT. Ésas traen su propio
 * encabezado adentro del iframe —con sus filtros y sus botones—, así que un
 * segundo título arriba serían dos encabezados apilados diciendo lo mismo.
 *
 * Y SI LA RUTA NO ES DE NINGUNA SECCIÓN, no dibuja nada. Inventar un título
 * ("Inicio", "Detalle") para una pantalla que la lista no conoce sería empezar
 * a mantener dos catálogos — que es de donde venimos.
 */

const Cabeza = () => {
  const { pathname, search } = useLocation();
  // Las del panel traen su propio encabezado adentro del iframe.
  if (pathname.startsWith("/panel/")) return null;

  // La query va incluida: la agenda de turnos es `/rto?vista=agenda` y sin
  // esto se presentaba como «RTO de tractores» aunque se estuviera anotando
  // el registro de un chofer.
  const d = tituloDe(pathname, undefined, search);
  if (!d) return null;

  const [titulo, sub] = d;
  const universo = universoDe(pathname, undefined, search);

  return (
    <header className="hub-cabeza">
      <div>
        <h1>{titulo}</h1>
        {sub && <p>{sub}</p>}
      </div>
      {/* El sector, a la derecha y en chico. Sirve de reojo para saber en qué
          parte del sistema estás sin volver a leer el rail. */}
      {universo && <span className="hub-cabeza-universo">{universo}</span>}
    </header>
  );
};

export default Cabeza;
